import React from 'react'
import {
    Button,
    Media,
} from "reactstrap";

const propTypes = {};

class ClientSearchTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: props.client,
            classTickets: props.classTickets,
        };
    }

    render() {
        return (
            <Button
                style={{width: "100%", marginLeft: 2, marginRight: 2, marginTop: 2}}
                color="secondary"
                onClick={e => this.props.addToClass(e, this.state.client.id)}
            >
                <Media>
                    <a
                        className="avatar mr-3"
                    >
                        <img
                            alt="..."
                            src={this.state.client && this.state.client.photo ? this.state.client.photo : require("assets/img/icons/common/generic-person-white.svg").default}
                        />
                    </a>
                    {this.state.client && this.state.client.name ? this.state.client.name : ""}
                </Media>
            </Button>
        )
    }
}

ClientSearchTableRow.propTypes = propTypes;

export default ClientSearchTableRow;